import React from 'react';
import './styles.less';

// This footer is owned by this app, not fetched from bex-api-global-navigation.
// That dependency sat on the first-paint critical path (SSR blocked on it inside
// the page-data Promise.all) with ~10s latency and a high failure rate, and even
// when it succeeded it did not reliably return the section links. Owning a static
// logo + copyright removes bex from the render path entirely. See AGENTS.md.

// Vrbo brand wordmark, served from Vrbo's DMS. Rendered as a plain <img src> so a
// failure to load degrades to just the copyright line — it never blocks render.
const VRBO_LOGO_SRC =
    'https://www.vrbo.com/_dms/interstitial/logo.svg?locale=en_US&siteid=9001001';
const VRBO_HOME_URL = 'https://www.vrbo.com';

// Yearless so it never needs an annual update.
export const COPYRIGHT =
    '© Vrbo, an Expedia Group company. All rights reserved. Vrbo and the Vrbo logo are trademarks or registered trademarks of HomeAway.com, Inc.';

const Footer = (): JSX.Element => (
    <footer className="global-navigation-footer">
        <div className="global-navigation-footer-container">
            <div className="global-navigation-footer-inner-container">
                <ul className="logo-container">
                    <li className="logo-inner-container">
                        <a
                            className="logo-redirection-link"
                            href={VRBO_HOME_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Vrbo, opens in a new window"
                        >
                            <img
                                className="logo-image"
                                src={VRBO_LOGO_SRC}
                                alt="Vrbo"
                                width="100%"
                                loading="lazy"
                            />
                        </a>
                    </li>
                </ul>
                <hr className="footer-content-divider" />
                <ul className="footer-copyright-outer-container">
                    <li
                        className="footer-copyright-inner-container"
                        role="listitem"
                    >
                        <div className="footer-copyright">
                            <span className="footer-copyright-text">
                                {COPYRIGHT}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
);

export default Footer;
